import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  //Tab组件里, sectionComponent.child.current 是对应的渲染分选组件
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ componentDefaultValue });

  sectionComponent.child.map((child, i) => {
    if (child.current != null) {
      child.current?.setState({ searchParameter: { moduleId: parameter }, moduleId: parameter });
      child.current?.child.current?.setState({ moduleId: parameter });

      child.current?.customForm.current?.setState({ componentDefaultValue: [], componentDataSource: [] });
      setTimeout(() => {
        child.current?.getSectionDataByDefault();
      }, config.setTimeoutMilliSecond);
    }
  })
}

export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'BillableTaskTemplate') {
      child.current?.setState({ showModal: true, componentType: 'Create', isFormModified: false });
      setTimeout(() => {
        child.current?.customForm.current?.formRef.current?.resetFields();
      }, config.setTimeoutMilliSecond);
    }
  })
}
